import { clsx } from 'clsx'
import { forwardRef } from 'react'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

const Textarea = forwardRef(({ 
  label, 
  error, 
  hint,
  rows = 3,
  className = '',
  ...props 
}, ref) => {
  const { isMobileUI, isAdminAppUI } = useLayoutVariant()
  
  return (
    <div className="w-full">
      {label && (
        <label className={clsx(
          'block text-sm font-medium mb-1.5',
          isAdminAppUI ? 'text-[#7a8fa6]' : isMobileUI ? 'text-gray-700' : 'text-gray-700 dark:text-gray-300'
        )}>
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        rows={rows}
        className={clsx(
          'block w-full transition-colors resize-y',
          isAdminAppUI
            ? 'rounded-[10px] border border-[#243246] bg-[#1f2d40] px-3 py-2.5 text-sm text-[#e8edf5] placeholder-[#3d5166] focus:outline-none focus:ring-2 focus:ring-[#00c896]/25 focus:border-[#00c896]'
            : isMobileUI
            ? 'rounded-2xl border-0 bg-gray-50 px-4 py-3 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500/50'
            : 'rounded-lg border px-3 py-2 text-sm',
          !isMobileUI && !isAdminAppUI && (
            error
              ? 'border-red-300 dark:border-red-600 text-red-900 dark:text-red-200 placeholder-red-300 dark:placeholder-red-700 focus:border-red-500 dark:focus:border-red-500 focus:ring-red-500 dark:focus:ring-red-500'
              : 'border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 bg-white dark:bg-gray-800 focus:border-primary-500 dark:focus:border-primary-400 focus:ring-primary-500 dark:focus:ring-primary-400'
          ),
          !isMobileUI && !isAdminAppUI && 'focus:outline-none focus:ring-2 focus:ring-offset-0',
          'disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-500 dark:disabled:text-gray-400 disabled:cursor-not-allowed',
          error && isMobileUI && 'ring-2 ring-red-500/50',
          error && isAdminAppUI && 'border-[#ef5350] focus:ring-[#ef5350]/25 focus:border-[#ef5350]',
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1.5 text-sm text-red-700 dark:text-red-400">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1.5 text-sm text-gray-600 dark:text-gray-500">{hint}</p>
      )}
    </div>
  )
})

Textarea.displayName = 'Textarea'

export default Textarea

